import React, { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton"; // same as in NonMayaMerchantInfo
import "./UnifiedFormStyles.css";

function NotJoiningMayaMallProgram({ navigation, primaryDetails, setPrimaryDetails }) {
  const [isError, setIsError] = useState({});

  const reasonOptions = [
    "For management approval",
    "Clean store policy",
    "Clean counter policy",
    "Competitor preference",
    "Refused to join due to company and HQ policy",
    "Approver is not available - for revisit",
    "Issues with Maya terminal and/or static QR",
    "Low sales of store",
    "Data privacy",
    "Needs email exchange between Maya and HQ",
    "Non Maya Merchant",
    "Other reason"
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPrimaryDetails(prev => ({
      ...prev,
      [name]: value
    }));
    if (isError[name]) {
      setIsError(prev => ({ ...prev, [name]: false }));
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!primaryDetails.not_joining_program_reason) {
      errors.not_joining_program_reason = true;
    }
    setIsError(errors);
    return Object.keys(errors).length === 0;
  };

  const handleNext = () => {
    if (validateForm()) {
      navigation.go("point-of-contact");
    } else {
      toast.error("Please select a reason for not joining Maya Mall Program.");
    }
  };

  const handleBack = () => {
     navigation.previous();
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">NOT JOINING MAYA MALL PROGRAM</h4>
              <p className="form-desc">Please provide the reason for not joining</p>
            </div>

            <div className="form-main">
              <div className="form-main-content">
                <Form className="form-form">
                  {/* Reason for Not Joining */}
                  <Form.Group className="mb-4" controlId="not_joining_program_reason">
                    <Form.Label className="form-label">
                      Reason for not joining Maya Mall Program
                      <span className="form-required">*</span>
                    </Form.Label>
                    <div className="form-radio-group">
                      {reasonOptions.map((reason, index) => (
                        <div
                          key={reason}
                          className={`form-radio-item ${
                            primaryDetails.not_joining_program_reason === reason ? "selected" : ""
                          }`}
                        >
                          <Form.Check
                            type="radio"
                            name="not_joining_program_reason"
                            value={reason}
                            label={reason}
                            onChange={handleInputChange}
                            checked={primaryDetails.not_joining_program_reason === reason}
                            className="form-radio"
                          />
                        </div>
                      ))}
                    </div>
                    {isError.not_joining_program_reason && (
                      <div className="form-error">
                        Please select a reason for not joining Maya Mall Program.
                      </div>
                    )}
                  </Form.Group>

                  {/* Other Reason Text Field */}
                  {primaryDetails.not_joining_program_reason === "Other reason" && (
                    <Form.Group className="mb-4" controlId="other_not_joining_reason">
                      <Form.Label className="form-label">
                        Other reason for not joining Maya Mall Program
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="other_not_joining_reason"
                        value={primaryDetails.other_not_joining_reason || ""}
                        onChange={handleInputChange}
                        placeholder="Short answer text"
                        className="form-input"
                      />
                    </Form.Group>
                  )}

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back
                    </AppButton>
                    <AppButton onClick={handleNext} variant="next" className="form-btn variant-primary">
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default NotJoiningMayaMallProgram;
